import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { NUMBER_OF_CARS_PER_PAGE, DELAY } from '../../constants';
import setActivePage from '../../redux/actions/pagination';
import setShowCars from '../../redux/actions/carCard';
import { scrollPageToTop } from '../../utilites';

export default () => {
  const cars = useSelector((state) => state.catalog.cars);
  const activePage = useSelector((state) => state.pagination.activePage);
  const pagesCount = Math.ceil(cars.length / NUMBER_OF_CARS_PER_PAGE);
  const pagination = new Array(pagesCount).fill(null);
  const dispatch = useDispatch();

  return pagination.map((elem, index) => {
    const classList = index === activePage ? 'page-item active' : 'page-item';
    return (
      <li className={classList} key={`page${Math.random()}`}>
        <a
          href="#main-content"
          className="page-link"
          onClick={(e) => {
            e.preventDefault();
            if (pagination.length > 1) {
              dispatch(setShowCars(false));
              setTimeout(() => {
                dispatch(setActivePage(index));
                scrollPageToTop();
              }, DELAY);
            }
          }}
        >
          {index + 1}
        </a>
      </li>
    );
  });
};
